@if (form) {
  <form class="form" [formGroup]="form">
    @if (loading) {
      <div class="loading">
        <p-progressSpinner></p-progressSpinner>
        <div class="spinnerlabel">Loading report templates...</div>
      </div>
    } @else {
      <div class="form-section">
        <div class="form-section-info">
          <h4>Managed Templates</h4>
          <div class="description">Choose from a set of standard report templates.</div>
        </div>
        <div class="form-section-content flex">
          <div class="form-item">
            <div class="form-item-content templates">
              @for (template of baseTemplates; track template.id) {
                <div class="template" [ngClass]="{'selected': selectedTemplate === template.id }" (click)="selectTemplate(template)">
                  <div class="template-label">{{ template.name }}</div>
                  <div class="template-description">{{ template.description || '' }}</div>
                  <div class="template-meta">
                    @if (template.language) {
                      <div>{{template.language}}</div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      @if (allowCustomReports) {
        <div class="form-section">
          <div class="form-section-info">
            <h4>Project specific Templates</h4>
            <div class="description">Choose from templates specific to your project.</div>
          </div>
          <div class="form-section-content flex">
            <div class="form-item">
              <div class="form-item-content templates">
                @for (template of customTemplates; track template.id) {
                  <div class="template" [ngClass]="{'selected': selectedTemplate === template.id }" (click)="selectTemplate(template)">
                    <p-button class="delete-template-btn" icon="true" styleClass="p-button-outlined p-button-danger" pTooltip="Delete template" (click)="$event.stopPropagation(); deleteTemplate(template)">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </p-button>
                    <div class="template-label">{{ template.name }}</div>
                    <div class="template-description">{{ template.description || '' }}</div>
                    <div class="template-meta">
                      @if (template.language) {
                        <div>{{template.language}}</div>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="add-template-button">
                <p-button label="New Template" styleClass="p-button-secondary" (click)="openCreateTemplateDialog()">
                  <fa-icon [icon]="faPlus"></fa-icon>
                </p-button>
              </div>
            </div>
          </div>
        </div>
      }
    }
    @if (selectedTemplate) {
      <div class="form-section">
        <div class="form-section-info">
          <h4>Configure Report Generators</h4>
          <div class="description">Configure how the report is being generated.</div>
        </div>
        <div class="form-section-content flex">
          <div class="configuration-header">
            <div class="chevron" (click)="toggleConfigurationHidden()">
              <fa-icon [icon]="faChevronRight" [ngClass]="{'collapsed': configurationHidden}"></fa-icon>
            </div>
            <label class="configuration-label">Configuration</label>
          </div>
          @if (!configurationHidden) {
            <div class="configuration"></div>
            <div class="form-item">
              <div class="form-label">Report Name</div>
              <div class="form-item-content">
                <wm-editable-inlinetext formControlName="name" [saveIcon]="faCheck" [renderHtml]="false"></wm-editable-inlinetext>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Report Description</div>
              <div class="form-item-content">
                <wm-editable-inlinetext formControlName="description" [saveIcon]="faCheck"></wm-editable-inlinetext>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Parameters</div>
              <div class="form-item-content">
                @if (activeConfiguration) {
                  <wm-report-parameter-editor formControlName="parameters"></wm-report-parameter-editor>
                }
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Finding Filters</div>
              <div class="form-item-content">
                <p-multi-select [options]="availableSeverities"
                                [(ngModel)]="selectedFindingSeverities"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="select Severities to include"></p-multi-select>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Report Section Generators</div>
              <div class="form-item-content">
                <wm-report-section-generators
                  [generatorConfigs]="activeConfiguration?.sectionGenerators"
                  [currentFormGroup]="form.get('subsections')"
                  [auditId]="config.auditId"
                  [assessmentTasks]="assessmentTasks"
                  [states]="states"
                  [testObjects]="testObjects"
                  [auditRequirements]="auditRequirements"
                  [specsList]="specsList"
                  [specs]="specs"
                  [statesByTestObjectId]="statesByTestObjectId"
                  [testObjectsById]="testObjectsById"
                  [activitiesLoading]="activitiesLoading"
                  [selectedFindingSeverities]="selectedFindingSeverities"
                  (activitiesFilterChanged)="onActivitiesFilterChanged($event)">
                </wm-report-section-generators>
              </div>
            </div>
          }
          @if (infoMessage) {
            <div class="info">
              {{ infoMessage }}
            </div>
          }
          <div class="buttons">
            @if (!creatingReport) {
              <button pButton type="button" (click)="submit()" label="{{ submitLabel }}" class="ui-button-outline" [disabled]="!form.valid">
                <fa-icon [icon]="faPlay"></fa-icon>
              </button>
            }
            @if (creatingReport) {
              <button pButton type="button" label="{{ submitLabel }}" class="ui-button-outline" [disabled]="true">
                <fa-icon [icon]="faSyncAlt" [animation]="'spin'"></fa-icon>
              </button>
            }
          </div>
        </div>
      </div>
    }
  </form>
}
